import { z } from 'zod';

/** Цвет заливки ФИО в «Базе», при котором строка попадает в ЧС. */
export const baseBlacklistSettingsSchema = z.object({
  color: z.string().trim().regex(/^#[0-9a-f]{6}$/i, 'Укажите цвет в формате #RRGGBB')
    .transform((value) => value.toLowerCase()),
}).strict();

export type BaseBlacklistSettings = z.infer<typeof baseBlacklistSettingsSchema>;

export const DEFAULT_BASE_BLACKLIST_SETTINGS: BaseBlacklistSettings = { color: '#ff0000' };
